@if (errors?.formatError) {
	<div class="error-bar">
		<span [innerHTML]="errors.formatError"></span>
	</div>
}

@if (errors?.sizeExceeded) {
	<div class="error-bar">
		<span [innerHTML]="errors.sizeExceeded"></span>
	</div>
}

@if (errors?.httpError) {
	<div class="error-bar">
		<span [innerHTML]="errors.httpError"></span>
	</div>
}

@if (errors?.serverError) {
	<div class="error-bar">
		<span [innerHTML]="errorFormatter(errors.serverError)"></span>
	</div>
}
